let config = {}
config.baseURL = 'https://api.emulzint.innovareti.com.br/api/'
config.normalURL = 'https://api.emulzint.innovareti.com.br/'

export default config



// WEBPACK FOOTER //
// ./src/config/production.js